import clsx from "clsx";
import dialogStyles from "./dialogStyles.module.css";
import { Menu, MenuItem } from "@mui/material";
import DialogHeaderButton from "./buttonsTools/DialogHeaderButton";
import SearchIcon from "@mui/icons-material/Search";
import UpdateIcon from "@mui/icons-material/Update";
import ViewComfyOutlinedIcon from "@mui/icons-material/ViewComfyOutlined";
import SpaceDashboardOutlinedIcon from "@mui/icons-material/SpaceDashboardOutlined";
import VerticalAlignCenterOutlinedIcon from "@mui/icons-material/VerticalAlignCenterOutlined";
import AccountBoxOutlinedIcon from "@mui/icons-material/AccountBoxOutlined";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import FilterAltOffOutlinedIcon from "@mui/icons-material/FilterAltOffOutlined";
import React, { ReactElement, useEffect, useState } from "react";
import { smetaModals } from "../../../Tools/modalManager";
import HandleGrouping from "./HandleGrouping";
import { getStyleWindow } from "../../../Tools/Tools";

/**
 * Иконки для кнопок шапки диалогов
 */
const icons: { [key: string]: React.JSX.Element } = {
  rightSplit: <AccountBoxOutlinedIcon style={{ fontSize: "large" }} />,
  leftSplit: <SpaceDashboardOutlinedIcon style={{ transform: "rotate(+180deg)", fontSize: "large" }} />,
  bottomSplit: <ViewComfyOutlinedIcon style={{ fontSize: "large" }} />,
  filter: <FilterAltOutlinedIcon style={{ fontSize: "large" }} />,
  deleteFilter: <FilterAltOffOutlinedIcon style={{ fontSize: "large" }} />,
  search: <SearchIcon style={{ fontSize: "large" }} />,
  update: <UpdateIcon />,
  grouping: <VerticalAlignCenterOutlinedIcon style={{ transform: "rotate(+90deg)", fontSize: "large" }} />,
};

/**
 * Дефолтные подсказки для кнопок шапки диалогов
 */
const defaultTitle: { [key: string]: string } = {
  rightSplit: "Пользователи",
  leftSplit: "Каталог",
  bottomSplit: "Детализация",
  filter: "Отфильтровать",
  deleteFilter: "Снять фильтр",
  search: "Поиск",
  update: "Обновить",
  grouping: "Объеденить...",
};

interface Props {
  buttons: { [key: string]: boolean } & {
    rightSplit?: boolean;
    leftSplit?: boolean;
    bottomSplit?: boolean;
    filter?: boolean;
    deleteFilter?: boolean;
    search?: boolean;
    update?: boolean;
    grouping?: boolean;
  };
  funcs: { [key: string]: (ev?: any) => void } & {
    rightSplit?: (ev?: any) => void;
    leftSplit?: (ev?: any) => void;
    bottomSplit?: (ev?: any) => void;
    filter?: (ev?: any) => void;
    deleteFilter?: (ev?: any) => void;
    search?: (ev?: any) => void;
    update?: (ev?: any) => void;
    grouping?: (ev?: any) => void;
  };
  title?: { [key: string]: string } & {
    rightSplit?: string;
    leftSplit?: string;
    bottomSplit?: string;
    filter?: string;
    deleteFilter?: string;
    search?: string;
    update?: string;
    grouping?: string;
  };
  disabled: { [key: string]: boolean } & {
    rightSplit?: boolean;
    leftSplit?: boolean;
    bottomSplit?: boolean;
    filter?: boolean;
    deleteFilter?: boolean;
    search?: boolean;
    update?: boolean;
    grouping?: boolean;
  };
}

/**
 * Универсальный компонент с кнопками управления базовыми функциями диалоговых окон
 *
 * Поля компонента:
 *    1.[anchorEl, setAnchorEl]
 *    2.
 *    3.
 *
 * @param {Object} [props]
 * @param {Object} [props.buttons] объект определяющий отображение кнопок
 * @param {boolean} [props.buttons.rightSplit] отображение кнопки управления правым разделителем
 * @param {boolean} [props.buttons.leftSplit] отображение кнопки управления левым разделителем
 * @param {boolean} [props.buttons.bottomSplit] отображение кнопки управления нижним разделителем
 * @param {boolean} [props.buttons.filter] отображение кнопки управления фильтром
 * @param {boolean} [props.buttons.deleteFilter] отображение кнопки удаления фильтра
 * @param {boolean} [props.buttons.search] отображение кнопки управления поиском
 * @param {boolean} [props.buttons.update] отображение кнопки обновления диалога
 * @param {boolean} [props.buttons.grouping] отображение кнопки группировки
 * @param {Object} [props.funcs] объект с функциями для кнопок
 * @param {Function} [props.funcs.rightSplit] функция на клик по кнопке управления правым разделителем
 * @param {Function} [props.funcs.leftSplit] функция на клик по кнопке управления левым разделителем
 * @param {Function} [props.funcs.bottomSplit] функция на клик по кнопке управления нижним разделителем
 * @param {Function} [props.funcs.filter] функция на клик по кнопке управления фильтром
 * @param {Function} [props.funcs.deleteFilter] функция на клик по кнопке удаления фильтра
 * @param {Function} [props.funcs.search] функция на клик по кнопке управления поиском
 * @param {Function} [props.funcs.update] функция на клик по кнопке обновления диалога
 * @param {Function} [props.funcs.grouping] функция на клик по кнопке группировки
 * @param {Object} [props.title] объект для изменения заголовков для кнопок
 * @param {string} [props.title.rightSplit] заголовок для кнопки управления правым разделителем
 * @param {string} [props.title.leftSplit] заголовок для кнопки управления левым разделителем
 * @param {string} [props.title.bottomSplit] заголовок для кнопки управления нижним разделителем
 * @param {string} [props.title.filter] заголовок для кнопки управления фильтром
 * @param {string} [props.title.deleteFilter] заголовок для кнопки удаления фильтра
 * @param {string} [props.title.search] заголовок для кнопки управления поиском
 * @param {string} [props.title.update] заголовок для кнопки обновления диалога
 * @param {string} [props.title.grouping] заголовок для кнопки группировки
 * @param {Object} [props.disabled] объект блокировки кнопок
 * @param {boolean} [props.disabled.rightSplit] блокировка кнопки управления правым разделителем
 * @param {boolean} [props.disabled.leftSplit] блокировка кнопки управления левым разделителем
 * @param {boolean} [props.disabled.bottomSplit] блокировка кнопки управления нижним разделителем
 * @param {boolean} [props.disabled.filter] блокировка кнопки управления фильтром
 * @param {boolean} [props.disabled.deleteFilter] блокировка кнопки удаления фильтра
 * @param {boolean} [props.disabled.search] блокировка кнопки управления поиском
 * @param {boolean} [props.disabled.update] блокировка кнопки обновления диалога
 * @param {boolean} [props.disabled.grouping] блокировка кнопки группировки
 *
 * @returns Возвращает компонент с настраиваемыми кнопками для шапки диалога
 */
export default function DialogHeaderButtons(props: Props): React.JSX.Element {
  const { buttons, funcs, title, disabled } = props;

  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);
  const [buttonsJsx, setButtonsJsx] = useState<ReactElement<any>[] | null>(null);

  useEffect(() => {
    setButtonsJsx(getButtons());
  }, [disabled, open]);

  const handleClick = (event: any) => {
    setOpen(!open);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (value: string) => {
    handleGrouping(value);
    setOpen(false);
    setAnchorEl(null);
  };
  //кнопка из списка Объединить
  const handleGrouping = (module: string) => {
    smetaModals.open(<HandleGrouping id={"grouping_grid"} module={module} />, {
      Title: module,
      style: getStyleWindow("groupingOrg"),
      hiddenButton: true,
    });
  };

  const getButtons = () => {
    if (!buttons) return null;

    return Object.entries(buttons).map(([key, val]: [string, boolean]) => {
      if (key === "grouping") {
        return (
          <DialogHeaderButton
            key={`dialog-header-${key}`}
            title={title?.[key] || defaultTitle[key]}
            visible={val}
            icon={icons[key]}
            onClick={(ev) => {
              funcs?.[key]?.(ev);
              handleClick(ev);
            }}
          />
        );
      }
      return (
        <DialogHeaderButton
          key={`dialog-header-${key}`}
          title={title?.[key] || defaultTitle[key]}
          disabled={Boolean(disabled?.[key])}
          visible={val}
          icon={icons[key]}
          onClick={funcs?.[key]}
        />
      );
    });
  };

  return (
    <div className={clsx(dialogStyles.dialogHeaderContainer)}>
      {buttonsJsx}

      {/* {Выпадающий список для Объединения} */}
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={() => {
          setOpen(false);
          setAnchorEl(null);
        }}
        slotProps={{
          list: {
            "aria-labelledby": "basic-button",
          },
        }}
      >
        <MenuItem
          key={"group_org"}
          onClick={() => {
            handleClose("Объединить организации");
          }}
        >
          Объединить организации
        </MenuItem>
        <MenuItem
          key={"group_bank"}
          onClick={() => {
            handleClose("Объединить банки");
          }}
        >
          Объединить банки
        </MenuItem>
        <MenuItem
          key={"group_acc"}
          onClick={() => {
            handleClose("Объединить Счета");
          }}
        >
          Объединить Счета
        </MenuItem>
      </Menu>
    </div>
  );
}
